export default {
  testDescription: 'Default',
  id: '1', // D427
  name: 'Lorem Ipsum Dolor Sit Amet, Consete', // D425
  description:
    'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.', // D426
  servicePortal: 'portal xy', // D428
  bookedInstances: 2, // D429
  maxInstances: 5, // D430
  isExclusionGroupConflict: false, // S713
  promotionTypeId: 1, // S777
  price: {
    chargingIntervalFactor: 1,
    chargingIntervalOverrideText: null,
    chargingIntervalUnit: 3,
    isExact: true,
    minimumCommitmentPeriodFactor: 24,
    minimumCommitmentPeriodUnit: 3,
    priceDisplay: '9,90 €',
    promotion: {
      durationFactor: 1,
      durationUnit: 3,
      priceDisplay: '4,50 €',
      promotionEnd: null,
      setupPrice: {
        priceDisplay: '0,50 €',
      },
    },
    setupPrice: {
      priceDisplay: '1,23 €',
    },
  },
};
